import * as React from 'react';

export interface ContentProps {
  /** Any element to be rendered inside under title */
  children?: React.ReactNode;
  /** Define styles through a classname */
  className?: string;
  /** Remove paddings from the content */
  noPadding?: boolean;
  /** Makes the Content stretch to max height in a container */
  stretchVertically?: boolean;
}
